export { ReactComponent as IcoBetRecord } from './IcoBetRecord.svg';
export { ReactComponent as IcoBetViewA } from './IcoBetViewA.svg';
export { ReactComponent as IcoBetViewADim } from './IcoBetViewADim.svg';
export { ReactComponent as IcoBetViewB } from './IcoBetViewB.svg';
export { ReactComponent as IcoBetViewBDim } from './IcoBetViewBDim.svg';
export { ReactComponent as IcoBetViewSwitch } from './IcoBetViewSwitch.svg';
export { ReactComponent as IcoChangePassword } from './IcoChangePassword.svg';
export { ReactComponent as IcoChatRoom } from './IcoChatRoom.svg';
export { ReactComponent as IcoChecked } from './IcoChecked.svg';
export { ReactComponent as IcoExploreRewards } from './IcoExploreRewards.svg';
export { ReactComponent as IcoFeedback } from './IcoFeedback.svg';
export { ReactComponent as IcoFullScreen } from './IcoFullScreen.svg';
export { ReactComponent as IcoGameAgreement } from './IcoGameAgreement.svg';
export { ReactComponent as IcoGameRules } from './IcoGameRules.svg';
export { ReactComponent as IcoGiftRecord } from './IcoGiftRecord.svg';
export { ReactComponent as IcoLanguage } from './IcoLanguage.svg';
export { ReactComponent as IcoLite } from './IcoLite.svg';
export { ReactComponent as IcoLiteTooltips } from './IcoLiteTooltips.svg';
export { ReactComponent as IcoLogout } from './IcoLogout.svg';
export { ReactComponent as IcoMemberReport } from './IcoMemberReport.svg';
export { ReactComponent as IcoSettingMenu } from './IcoSettingMenu.svg';
export { ReactComponent as IcoSettingMenuInGame } from './IcoSettingMenuInGame.svg';
export { ReactComponent as IcoSound } from './IcoSound.svg';